import { withAnnouncementLock } from './update-announcement'

export const securityAnnouncement = {
  id: 'account-safety',
  version: 1,
  enabled: true,
  updatedAt: '2026-09-20',
  expiresAt: '2026-10-08T00:00:00+08:00',
  reportPath: '/security',
} as const
export const SECURITY_STORAGE_KEY = 'maple-log:security-announcement'
export const securityAnnouncementKey = `${securityAnnouncement.id}:${securityAnnouncement.version}`

export function securityAnnouncementActive(now = Date.now()): boolean {
  return securityAnnouncement.enabled && now < Date.parse(securityAnnouncement.expiresAt)
}

export class SecurityAnnouncementHistory {
  private acknowledged = new Set<string>()
  constructor(private storage: () => Pick<Storage, 'getItem' | 'setItem'> = () => localStorage) {}
  hasSeen(id = securityAnnouncementKey): boolean {
    if (this.acknowledged.has(id)) return true
    try { return this.storage().getItem(SECURITY_STORAGE_KEY) === id } catch { return false }
  }
  acknowledge(id = securityAnnouncementKey): void {
    this.acknowledged.add(id)
    try { this.storage().setItem(SECURITY_STORAGE_KEY, id) } catch { /* This page still remembers. */ }
  }
}
export const securityHistory = new SecurityAnnouncementHistory()
export function withSecurityAnnouncementLock(action: () => Promise<void>, signal: AbortSignal): Promise<void> {
  return withAnnouncementLock(action, signal, 'maple-log:security-announcement')
}
